import { EventEmitter, Injectable, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  dialog = inject(MatDialog);

  public currentNotification: Notification;
  public notificationClicked: EventEmitter<string> = new EventEmitter<string>();
  public permissionGranted: boolean;

  constructor() {
    if (Notification.permission === "granted") {
      this.permissionGranted = true;
    } else {
      (Notification as any).requestPermission().then((permission) => {
        this.permissionGranted = permission === "granted";
      });
    }
  }

  public sendNotification(notificationText: string, options?: NotificationOptions): void {
    if (this.currentNotification) {
      this.currentNotification.close();
    }

    if (this.permissionGranted) {
      this.currentNotification = new Notification(notificationText, options);

      this.currentNotification.onclick = () => {
        parent.focus();
        this.notificationClicked.emit(options.data["notificationName"]);
      };
    }
  }
}
